import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModalCrud from "./Modal";
import { DoLogout, provinces } from "../Utils";

export default function DojosList() {
  const ESTADO_PUBLICADO = "Publicado";

  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [dojos, setDojos] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [dojoDetail, setDojoDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));

  useEffect(() => {
    BuildBase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const BuildBase = async () => {
    setLoading(true);

    // todo: reemplazar con usuario activo, ejemplo id 423
    const dojosData = await axios
      .get(
        `${API_URL}/dojos?sort[0]=name%3Aasc&pagination[pageSize]=500&populate=*&filters[$or][0][responsible][id][$eq]=${usuario.id}&filters[$or][1][administrative][id][$eq]=${usuario.id}`,
        headerRequest
      )
      .catch((error) => {
        if (error.response.status === 401) DoLogout();
      });

    const dojos = dojosData.data.data;
    // todo: reemplazar con usuario activo
    await axios
      .get(
        //`${API_URL}/temp-dojos?pagination[pageSize]=500&populate=*&filters[responsible][id][$eq]=423&state=NEW`,
        `${API_URL}/temp-dojos?pagination[pageSize]=500&populate=*&filters[responsibleDocNumber][$eq]=${usuario.docNumber}&state=NEW`,
        headerRequest
      )
      .then((dojosTempData) => {
        const dojosTemp = dojosTempData.data.data;
        console.log({ dojos });
        console.log({ dojosTemp });
        for (let i = 0; i < dojosTemp.length; i++) {
          const dojo = dojos.find(
            ({ id }) => id == dojosTemp[i].attributes.idDojo
          );
          if (dojo?.id) {
            dojosTemp[i] = dojo;
            dojosTemp[i].state = "Pendiente";
          }
        }
      });

    setDojos(dojos);
    setLoading(false);
  };

  const DataEdit = (e) => {
    setDojoDetail(e);
    setShowModal(true);
  };

  const renderData = (
    <>
      <Table striped hover size="sm" responsive="sm">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Localidad</th>
            <th className="d-none d-lg-table-cell">Provincia</th>
            <th className="d-none d-lg-table-cell">Estado</th>
            <th>
              Acciones
              {/* <Button
                size="sm"
                variant="success"
                onClick={() => DataEdit(null)}
              >
                CREAR
              </Button> */}
            </th>
          </tr>
        </thead>
        <tbody>
          {dojos.length < 1 ? (
            <tr>
              <td colSpan="6" align="center">
                No hay datos.
              </td>
            </tr>
          ) : (
            dojos.map((e) => (
              <tr id={e.id} key={e.id}>
                <td align="left">{e.attributes.name}</td>
                <td align="left">{e.attributes.address}</td>
                <td align="left">{e.attributes.locality}</td>
                <td align="left" className="d-none d-lg-table-cell">
                  {provinces[e.attributes.province]}
                </td>
                <td align="left" className="d-none d-lg-table-cell">
                  {e.state == null ? ESTADO_PUBLICADO : e.state}
                </td>
                <td align="center" className="w140">
                  <>
                    <Link to={`/dojos/${e.id}/classes`}>
                      <Button size="sm" variant="success">
                        Clases
                      </Button>
                    </Link>
                    {/* <Button
                      size="sm"
                      className="me-2"
                      onClick={() => DataEdit(e)}
                      variant="warning"
                    >
                      Editar
                    </Button> */}
                  </>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3" fluid="lg">
      <h4>MIS DOJOS</h4>
      <p>Dojos de los que es responsable</p>
      {isLoading ? <Spinner animation="border" /> : renderData}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      <p style={{ fontSize: "0.8em", textAlign: "left" }}>
        <b>Estado</b> Pendiente: todavia no se procesaron sus últimas
        modificaciones
      </p>
      {showModal && (
        <ModalCrud
          show={showModal}
          dojo={dojoDetail}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) BuildBase();
          }}
        />
      )}
    </Container>
  );
}
